import React from 'react'

const Pipelines = () => {
  return (
    <div>Pipelines</div>
  )
}

export default Pipelines